<mat-form-field class="ss fuse-mat-dense" subscriptSizing="dynamic" [attr.data-testid]="testId">
  <mat-label *ngIf="label">{{ label }}</mat-label>
  <input
    matInput
    type="text"
    autocomplete="off"
    [attr.data-testid]="testId + '-input'"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [value]="text"
    [matAutocomplete]="auto"
    (input)="onInput($any($event.target).value)"
    (blur)="onBlur()" />
  <button
    *ngIf="hasValue && !disabled"
    type="button"
    matSuffix
    class="ss-clear"
    data-testid="searchable-select-clear"
    [attr.aria-label]="'common.clear' | transloco"
    (mousedown)="$event.preventDefault()"
    (click)="clear()">
    <mat-icon class="ss-clear-icon" svgIcon="heroicons_outline:x"></mat-icon>
  </button>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="pick($event.option.value)" panelWidth="auto">
    <mat-option *ngIf="allLabel" [value]="null">
      <span class="ss-option">
        <span class="ss-name">{{ allLabel }}</span>
      </span>
    </mat-option>
    <mat-option *ngFor="let option of filtered; trackBy: trackById" [value]="option.id">
      <span class="ss-option">
        <span class="ss-name">{{ option.name }}</span>
        <span *ngIf="option.count != null" class="ss-count">{{ option.count }}</span>
      </span>
    </mat-option>
    <div *ngIf="!filtered.length" class="ss-empty" data-testid="searchable-select-empty">
      {{ 'common.noResults' | transloco }}
    </div>
  </mat-autocomplete>
</mat-form-field>
